import React from "react";
import Routes from "./Routes";

import { createRoot } from "react-dom/client";


createRoot(document.getElementById('root')).render(<Routes />);